import { render, staticRenderFns } from "./videoForm.vue?vue&type=template&id=f38ae762&scoped=true"
import script from "./videoForm.vue?vue&type=script&lang=js"
export * from "./videoForm.vue?vue&type=script&lang=js"
import style0 from "./videoForm.vue?vue&type=style&index=0&id=f38ae762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ae762",
  null
  
)

export default component.exports